import { z } from "zod";
import { isValidTimeZone } from "@/lib/shopTimeZone";

// Shop settings form schema. Note: `workingHours` is intentionally NOT here —
// working hours are edited/saved independently by ShopConfiguration, and letting
// the form carry them causes stale-value reverts (WEBV3-125 defect A).
export const shopConfigSchema = z.object({
  dashboardScaling: z.enum(["scaleToFit", "noScaling"]).optional(),
  useShopHeroEmployeeJobTitle: z.boolean().optional(),
  showContainerLinkIcons: z.boolean().optional(),
  showLabelsAsTags: z.boolean().optional(),
  showCardTechnician: z.boolean().optional(),
  showAdditionalCardTechnicians: z.boolean().optional(),
  technicianWritebackEnabled: z.boolean().optional(),
  customerUpdates: z
    .object({
      enabled: z.boolean().default(true),
      defaultCompletedOnTimeBufferMin: z.number().default(15),
      defaultSnoozeBufferMin: z.number().default(30),
      autoCreateCustomerUpdates: z.boolean().default(true),
      requireComments: z.boolean().default(false),
      quickTimeOptions: z
        .array(
          z.object({
            label: z.string(),
            value: z.number(),
          })
        )
        .optional(),
    })
    .optional(),
  inboxPanel: z
    .object({
      showActivityFeed: z.boolean().default(true),
      showCustomerUpdates: z.boolean().default(true),
      showGoList: z.boolean().default(true),
      showMessages: z.boolean().default(true),
    })
    .optional(),
  promiseTime: z
    .object({
      pastDueColor: z.string().optional(),
    })
    .optional(),
  timeZone: z
    .string()
    .refine(isValidTimeZone, { message: "Not a valid IANA time zone" })
    .optional(),
});

export type ShopConfigFromZod = z.infer<typeof shopConfigSchema>;
